export default function shouldFlipCallback(prevData: any): boolean {
  return Boolean(!prevData);
}
